import USER_ROLES from "../../../../../../constants/userRoles.constants";

class OtherTabController {
    constructor(
        evaluationService,
        stepLearningGoalsService,
        learningAreaService,
        userService,
        $stateParams,
        $state,
        $mdDialog,
        $mdToast,
    ) {
        const learningAreaId = parseInt($stateParams.subjectAreaId);

        this.evaluationId = parseInt($stateParams.id);
        this.learningAreas = [];
        this.selectedSkills = [];
        this.stateChangeCheck = true;
        this.showOthers = false;
        this.othersLearningGoals = [];
        this.stepLearningGoalsService = stepLearningGoalsService;
        this.isFinished = false;
        this.learningGoalsForm = {};
        this.isAdmin = userService.isInRole(USER_ROLES.ROLE_ADMIN);

        learningAreaService.list().then(data => this.learningAreas = data);

        this.initGetSkillsFromLearningArea = () => {
            learningAreaService.getById(learningAreaId)
                .then((data) => {
                    this.allSkills = data;
                    evaluationService.getEvaluationData(this.evaluationId)
                        .then((evaluationData) => {
                            this.evaluationData = evaluationData;
                            this.isAdmin = userService.isInRole(USER_ROLES.ROLE_ADMIN);
                            this.isManager = evaluationData.isManager;
                            this.isFinished = evaluationService.isAfterFinish(evaluationData.status);
                            if(this.isFinished) {
                                this.stateChangeCheck = false;

                                evaluationService.getOthers('learning_goals', true, this.evaluationId).then((learningGoals) => {
                                    this.othersLearningGoals = learningGoals;
                                    this.allSkills.grades.forEach((grade) => {
                                        const updatedGrade = { ...grade };

                                        updatedGrade.skills.forEach((skill) => {
                                            const myGoal = this.evaluationData.learningGoals.find((myLearningGoal) => {
                                                return myLearningGoal.skillId === skill.id &&
                                                    myLearningGoal.gradeId === updatedGrade.id;
                                            });
                                            skill.myScore = myGoal ? myGoal.importance : null;
                                            skill.scoreACount = myGoal && myGoal.importance === "A" ? 1 : 0;
                                            skill.scoreNCount = myGoal && myGoal.importance === "N" ? 1 : 0;
                                            skill.scoreBCount = myGoal && myGoal.importance === "B" ? 1 : 0;
                                            skill.othersScores = [];
                                            skill.exclude = this.evaluationData.learningGoalsExclude
                                                .some(exclude => exclude.skillId === skill.id && exclude.exclude === '1');

                                            learningGoals.forEach((otherPerson) => {
                                                const otherGoal = otherPerson.learningGoals.find((myLearningGoal) => {
                                                    return myLearningGoal.skillId === skill.id &&
                                                        myLearningGoal.gradeId === updatedGrade.id;
                                                });
                                                if(otherGoal) {
                                                    switch (otherGoal.importance) {
                                                        case("A"):
                                                            skill.scoreACount++;
                                                            break;
                                                        case("B"):
                                                            skill.scoreBCount++;
                                                            break;
                                                        case("N"):
                                                            skill.scoreNCount++;
                                                            break;
                                                    }
                                                }
                                                skill.othersScores.push({
                                                    username: otherPerson.user.isDeleted ? 'Deleted User' : otherPerson.user.username,
                                                    importance: otherGoal ? otherGoal.importance : null
                                                });
                                            });
                                        });

                                        updatedGrade.skills.sort((prev, next) => {
                                            if (prev.scoreACount > next.scoreACount) {
                                                return -1;
                                            } else if (prev.scoreACount < next.scoreACount) {
                                                return 1;
                                            } else if (prev.scoreBCount > next.scoreBCount) {
                                                return -1;
                                            } else if (prev.scoreBCount < next.scoreBCount) {
                                                return 1;
                                            } else if (prev.scoreNCount > next.scoreNCount) {
                                                return -1;
                                            } else if (prev.scoreNCount < next.scoreNCount) {
                                                return 1;
                                            }
                                            return 0;
                                        })
                                    });

                                })
                            } else {
                                data.grades.forEach((grade) => {
                                    grade.skills.forEach((skill) => {
                                        const foundLearningGoal = evaluationData.learningGoals.find((learningGoal) => {
                                            return learningGoal.skillId === skill.id &&
                                                learningGoal.gradeId === grade.id;
                                        });
                                        skill.importance = foundLearningGoal ? foundLearningGoal.importance : null;
                                    });
                                });
                            }
                            this.allSkillsPristine = JSON.parse(angular.toJson(this.allSkills));
                        });
                });
        };

        this.initGetSkillsFromLearningArea();

        this.handleSaveCurrentTabClick = function(grades, id, redirect) {
            const learningGoals = [];
            grades.forEach((grade) => {
                grade.skills.forEach((skill) => {
                   if(skill.importance) {
                       learningGoals.push({
                           skillId: skill.id,
                           importance: skill.importance
                       });
                   }
               })
            });

            this.stateChangeCheck = false;
            stepLearningGoalsService.saveLearningGoals({learningGoals: learningGoals, areaId: learningAreaId}, this.evaluationData.id)
                .then(() => {
                    const isLastIndex = this.learningAreas.length &&
                        learningAreaId === this.learningAreas[[this.learningAreas.length - 1]].id;
                    const currentIndex = this.learningAreas.findIndex(x => x.id === learningAreaId);
                    this.displayPromptOnRedirct = false;
                    $mdToast.show(
                        $mdToast.simple()
                            .textContent('Your data has been saved successfully')
                            .position('top center')
                            .action('Hide')
                            .highlightAction(true)
                            .hideDelay(4000)
                            .toastClass("success-toast")
                    );
                    if (redirect) {
                        if (isLastIndex) {
                            $state.go(
                                `mini.newMiniPedagogicalApproach`,
                                { id: this.evaluationData.id }
                            );
                        } else {
                            $state.go(`mini.newMiniPedagogicalApproach.learningGoals.defaultSubjectArea`, {
                                id: this.evaluationData.id,
                                subjectAreaId: this.learningAreas[currentIndex + 1].id
                            });
                        }
                    }
                })
                .catch(err => {
                    console.log('sendBasicForm error: ', err);
                    $mdDialog.show(
                        $mdDialog.alert({
                            title: 'Some error occurred',
                            textContent: `Your data has not been saved. Please try again.`,
                            ok: 'OK'
                        })
                    );
                });
        };

        this.showEditSkillsPrompt = () => {
            $mdDialog.show({
                clickOutsideToClose: true,
                templateUrl: 'editSkillsDialog.tmpl.html',
                parent: angular.element(document.body),
                locals: {
                    areaid: learningAreaId
                },
                controller: function DialogController($scope, $mdDialog, areaid) {
                    $scope.closeDialog = function() {
                        $mdDialog.hide();
                    };
                    $scope.areaid = areaid;
                }
            })
            .then(function() {
                this.initGetSkillsFromLearningArea();
            }, function() {});
        };

        this.haveAnySkillSelected = (grade) => {
            return grade.skills.reduce((prev, skill) => prev + skill.scoreACount + skill.scoreBCount + skill.scoreNCount, 0);
        };
    }

    changeExcludeField(skillId, excludeStatus) {
        this.stepLearningGoalsService.updateExcludeField(this.evaluationId, skillId, excludeStatus);
    }

    $onDestroy() {
        if (!this.isFinished && this.stateChangeCheck && !angular.equals(this.allSkills, this.allSkillsPristine)) {
            this.handleSaveCurrentTabClick(this.allSkills.grades, this.allSkills.id, false);
        }
    }
}

export default OtherTabController;



// WEBPACK FOOTER //
// ./src/app/pages/evaluation/pages/stepLearningGoals/pages/otherTab/otherTabController.js